import { useFormikContext } from "formik";

import { useNavigationBlocker } from "@vega-core/hooks/useNavigationBlocker";

import { UnsavedChangesModal } from "./UnsavedChangesModal";

export function FormikUnsavedChangesModal() {
  const { dirty } = useFormikContext();
  const { isBlocked, proceed, cancel } = useNavigationBlocker(dirty);

  return (
    <UnsavedChangesModal
      cancel={cancel}
      isBlocked={isBlocked}
      proceed={proceed}
    />
  );
}
